import { useState } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { Combobox, IconButton } from "@similarweb/ui-components";

type EmployeeProfilesNewButtonProps = {
    canCreateShared: boolean;
    dataAutomation?: string;
    onNewEmployeeProfile: (isSharedWithAccount: boolean) => void;
};

export const EmployeeProfilesNewButton = ({
    canCreateShared,
    dataAutomation = "employee-profiles-new-button",
    onNewEmployeeProfile,
}: EmployeeProfilesNewButtonProps) => {
    const { translate } = useTranslate();
    const [isOpen, setIsOpen] = useState(false);

    const newProfileLabel = translate("si.employee-profiles.button.new");

    if (!canCreateShared) {
        return (
            <IconButton
                dataAutomation={dataAutomation}
                iconSize="xs"
                iconName="add"
                onClick={() => onNewEmployeeProfile(false)}
            >
                {newProfileLabel}
            </IconButton>
        );
    }

    const handleSelect = (isSharedWithAccount: boolean) => {
        setIsOpen(false);
        onNewEmployeeProfile(isSharedWithAccount);
    };

    return (
        <Combobox
            placement="bottom-end"
            isOpen={isOpen}
            onOpenChange={setIsOpen}
            width="fit-content"
            data-automation={`${dataAutomation}-combobox`}
        >
            <Combobox.Trigger>
                <IconButton
                    dataAutomation={`${dataAutomation}-trigger`}
                    iconSize="xs"
                    iconName="add"
                >
                    {newProfileLabel}
                </IconButton>
            </Combobox.Trigger>
            <Combobox.Content
                selectionMode="single"
                ariaLabel={newProfileLabel}
            >
                <Combobox.Option
                    id="private"
                    textValue={translate("si.employee-profiles.button.new.private")}
                    onClick={() => handleSelect(false)}
                    data-automation={`${dataAutomation}-private`}
                >
                    <Combobox.OptionLabel>{translate("si.employee-profiles.button.new.private")}</Combobox.OptionLabel>
                </Combobox.Option>
                <Combobox.Option
                    id="shared"
                    textValue={translate("si.employee-profiles.button.new.shared")}
                    onClick={() => handleSelect(true)}
                    data-automation={`${dataAutomation}-shared`}
                >
                    <Combobox.OptionLabel>{translate("si.employee-profiles.button.new.shared")}</Combobox.OptionLabel>
                </Combobox.Option>
            </Combobox.Content>
        </Combobox>
    );
};
